import script from "./PlacesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlacesPage.vue?vue&type=script&lang=ts&setup=true"

import "./PlacesPage.vue?vue&type=style&index=0&id=377e6174&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-377e6174"]])

export default __exports__